module.exports = __webpack_public_path__ + "img/系统管理select.aac419dc.svg";